/**
 * This follows the same behavior as URL. It builds a URL string from a given
 * path or URL and an optional base and returns the generated URL string.
 */
export function generateURL(path: string, base?: string): string {
  return new URL(path, base).toString()
}
